module.exports = "https://static.zego.com/_next/static/images/founder-stu-245e93356a9fea7f9a44ce1995fd86cb.jpg";